const NOTIFICATION_MESSAGE = {
  ERROR: 'ขออภัย มีบางอย่างผิดพลาด กรุณาลองใหม่อีกครั้ง',
  UPDATE_SUCCESS: 'บันทึกข้อมูลสำเร็จ'
}

export { NOTIFICATION_MESSAGE }